module.exports = __webpack_public_path__ + "img/taboola.d1ee1630.png";